import ChartComponents from './src/components/charts'
import DatabaseComponents from './src/components/database'
import VisualComponents from './src/components/visuals'
import ReportComponents from './src/components/reports'

export default {
   components: {
      
   },
   routes: [
      ...ChartComponents.routes,
      ...DatabaseComponents.routes,
      ...VisualComponents.routes,
      ...ReportComponents.routes,
   ],
   sub_routes: [
      ...ChartComponents.sub_routes,
      ...DatabaseComponents.sub_routes,
      ...VisualComponents.sub_routes,
      ...ReportComponents.sub_routes,
   ]
}

export const AnalyticsNav = [
   { 
      icon: 'fa fa-columns',component: 'Main_Dashboard', name: 'Dashboard', has_permission: false
   },
   { 
      icon: 'fa fa-database',component: 'Schema', name: 'Schema', has_permission: true, resource: 'schema'
   },
   { 
      icon: 'fa fa-table',component: 'Table', name: 'Table', has_permission: true, resource: 'table'
   },
   { 
      icon: 'fa fa-bullhorn',component: 'Events', name: 'Events', has_permission: true, resource: 'table'
   },
   { 
      icon: 'fa fa-puzzle-piece',component: 'Playground', name: 'Playground', has_permission: true, resource: 'table'
   },
   { 
      icon: 'fa fa-chart-pie',component: 'Visuals', name: 'Visuals', has_permission: true, resource: 'visualization'
   },
   { 
      icon: 'fa fa-filter',component: 'Filter', name: 'Filters', has_permission: true, resource: 'filter'
   },
   { 
      icon: 'fa fa-chart-bar',component: 'Dashboards', name: 'Dashboards', has_permission: true, resource: 'dashboard'
   },
   { 
      icon: 'fa fa-indent',component: 'EventStats', name: 'Event Stats', has_permission: true, resource: 'table'
   },
   { 
      icon: 'fa fa-paper-plane',component: 'Report', name: 'Reports', has_permission: true, resource: 'report'
   },
]